module.exports = __webpack_public_path__ + "img/zhengshu.f09b3424.png";